import { Injectable } from '@angular/core';
import { UserInfoConfiguration } from './user-info-configuration';

@Injectable({
  providedIn: 'root'
})
export class UserInfoConfigurationService {

  configuration: UserInfoConfiguration ={
    enabled:true,
    url:""
  };

  constructor() { }

  loadConfiguration(configuration) {
    this.configuration = configuration;
  }
}
